import EditProvider from './EditProvider'

export default EditProvider
